(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["monkeys-announcement"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('monkeys-countdown')) {
    customElements.define('monkeys-countdown', class extends HTMLElement {
      connectedCallback() {
        var end = parseInt(this.getAttribute('data-end'), 10);
        this.endMs = isFinite(end) ? end * 1000 : NaN;
        this.timeEl = this.querySelector('[data-countdown-time]');
        this.finished = this.getAttribute('data-finished') || '';
        this.format = this.getAttribute('data-format') || 'letters';
        var units = this.getAttribute('data-units') || 'dhms';
        this.showD = units.indexOf('d') >= 0;
        this.showH = units.indexOf('h') >= 0;
        this.showM = units.indexOf('m') >= 0;
        this.showS = units.indexOf('s') >= 0;
        if (!isFinite(this.endMs) || !this.timeEl) {
          return;
        }
        this.update = this.update.bind(this);
        this.update();
        this.interval = setInterval(this.update, 1000);
      }
      disconnectedCallback() {
        if (this.interval) {
          clearInterval(this.interval);
        }
      }
      update() {
        var diff = this.endMs - Date.now();
        if (diff <= 0) {
          clearInterval(this.interval);
          if (this.finished) {
            this.timeEl.textContent = this.finished;
          } else {
            this.style.display = 'none';
          }
          return;
        }
        var rem = Math.floor(diff / 1000);
        var vd = 0, vh = 0, vm = 0, vs = 0;
        if (this.showD) { vd = Math.floor(rem / 86400); rem -= vd * 86400; }
        if (this.showH) { vh = Math.floor(rem / 3600); rem -= vh * 3600; }
        if (this.showM) { vm = Math.floor(rem / 60); rem -= vm * 60; }
        if (this.showS) { vs = rem; }
        var p = function (n) { return n < 10 ? '0' + n : '' + n; };
        var out;
        if (this.format === 'colons') {
          var seg = [];
          if (this.showD) { seg.push(p(vd)); }
          if (this.showH) { seg.push(p(vh)); }
          if (this.showM) { seg.push(p(vm)); }
          if (this.showS) { seg.push(p(vs)); }
          out = seg.join(':');
        } else {
          out = '';
          if (this.showD) { out += vd + 'd '; }
          if (this.showH) { out += p(vh) + 'h '; }
          if (this.showM) { out += p(vm) + 'm '; }
          if (this.showS) { out += p(vs) + 's'; }
          out = out.replace(/\s+$/, '');
        }
        this.timeEl.textContent = out;
      }
    });
  }

  if (!customElements.get('monkeys-marquee')) {
    customElements.define('monkeys-marquee', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.monkeys-announcement__track');
        if (!this.track) {
          return;
        }
        this.seed = this.track.innerHTML;
        this.tries = 0;
        this.build = this.build.bind(this);
        this.build();
      }
      disconnectedCallback() {
        if (this.raf) {
          cancelAnimationFrame(this.raf);
        }
      }
      build() {
        var container = this.clientWidth;
        if (!container) {
          this.tries += 1;
          if (this.tries < 60) {
            this.raf = requestAnimationFrame(this.build);
          }
          return;
        }
        // Repeat the seed until a single tile is at least as wide as the bar...
        var guard = 0;
        while (this.track.scrollWidth < container && guard < 60) {
          this.track.insertAdjacentHTML('beforeend', this.seed);
          guard += 1;
        }
        // ...then duplicate that tile so translateX(-50%) loops seamlessly.
        this.track.insertAdjacentHTML('beforeend', this.track.innerHTML);
        var speed = parseFloat(this.getAttribute('data-speed'));
        this.track.style.animationDuration = (speed > 0 ? speed : 20) + 's';
        if (this.getAttribute('data-direction') === 'right') {
          this.track.classList.add('monkeys-announcement__track--right');
        }
        this.track.classList.add('is-animated');
      }
    });
  }

  if (!customElements.get('monkeys-rotator')) {
    customElements.define('monkeys-rotator', class extends HTMLElement {
      connectedCallback() {
        this.items = Array.prototype.slice.call(this.querySelectorAll('.monkeys-announcement__rotate-item'));
        if (this.items.length <= 1) {
          return;
        }
        this.idx = 0;
        var interval = parseInt(this.getAttribute('data-interval'), 10) || 4000;
        this.advance = this.advance.bind(this);
        this.timer = setInterval(this.advance, interval);
      }
      disconnectedCallback() {
        if (this.timer) {
          clearInterval(this.timer);
        }
      }
      advance() {
        this.items[this.idx].classList.remove('is-active');
        this.idx = (this.idx + 1) % this.items.length;
        this.items[this.idx].classList.add('is-active');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["monkeys-glass-header"] && !Shopify.designMode) return;
  try {
    
  /* Desktop sliding stroke indicator for the nav (no-op on mobile). */
  if (!customElements.get('monkeys-glass-header')) {
    customElements.define('monkeys-glass-header', class extends HTMLElement {
      connectedCallback() {
        this.setupNavIndicator();
      }
      /* A 1px outline glides to the hovered nav item. No-op on mobile
         (nav is display:none, hover never fires). */
      setupNavIndicator() {
        var nav = this.querySelector('.mgh__nav');
        var indicator = nav && nav.querySelector('.mgh__nav-indicator');
        if (!nav || !indicator) { return; }
        var move = function (a) {
          var nr = nav.getBoundingClientRect();
          var r = a.getBoundingClientRect();
          indicator.style.left = (r.left - nr.left) + 'px';
          indicator.style.top = (r.top - nr.top) + 'px';
          indicator.style.width = r.width + 'px';
          indicator.style.height = r.height + 'px';
          indicator.classList.add('is-visible');
        };
        Array.prototype.slice.call(nav.querySelectorAll('.mgh__nav-link')).forEach(function (a) {
          a.addEventListener('mouseenter', function () { move(a); });
          a.addEventListener('focus', function () { move(a); });
        });
        nav.addEventListener('mouseleave', function () { indicator.classList.remove('is-visible'); });
      }
    });
  }

  if (!customElements.get('monkeys-menu-drawer')) {
    customElements.define('monkeys-menu-drawer', class extends HTMLElement {
      connectedCallback() {
        this.panel = this.querySelector('.mgh__menu-panel');
        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
        this.toggle = this.toggle.bind(this);
        this.onKey = this.onKey.bind(this);
        var self = this;
        this.openers = Array.prototype.slice.call(document.querySelectorAll('[data-mgh-open][aria-controls="' + this.id + '"]'));
        this.closers = Array.prototype.slice.call(this.querySelectorAll('[data-mgh-close]'));
        this.openers.forEach(function (b) { b.addEventListener('click', self.toggle); });
        this.closers.forEach(function (b) { b.addEventListener('click', self.close); });
        Array.prototype.slice.call(this.querySelectorAll('[data-mgh-currency]')).forEach(function (sel) {
          sel.addEventListener('change', function () { if (sel.form) { sel.form.submit(); } });
        });
      }
      disconnectedCallback() {
        document.removeEventListener('keydown', this.onKey);
        document.documentElement.style.overflow = '';
        document.documentElement.style.paddingRight = '';
      }
      onKey(e) { if (e.key === 'Escape') this.close(); }
      toggle() { if (this.classList.contains('is-open')) { this.close(); } else { this.open(); } }
      open() {
        this.classList.add('is-open');
        this.setAttribute('aria-hidden', 'false');
        this.openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
        var sbw = window.innerWidth - document.documentElement.clientWidth;
        document.documentElement.style.overflow = 'hidden';
        if (sbw > 0) { document.documentElement.style.paddingRight = sbw + 'px'; }
        document.addEventListener('keydown', this.onKey);
        if (this.panel) { this.panel.focus({ preventScroll: true }); }
      }
      close() {
        this.classList.remove('is-open');
        this.setAttribute('aria-hidden', 'true');
        this.openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
        document.documentElement.style.overflow = '';
        document.documentElement.style.paddingRight = '';
        document.removeEventListener('keydown', this.onKey);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["monkeys-urgency-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n) { return String(n).padStart(2, '0'); }
    function initBar(el) {
      var timeEl = el.querySelector('.murg__time');
      if (!timeEl) return;
      var mode = el.getAttribute('data-countdown');
      var mins = parseInt(el.getAttribute('data-minutes') || '60', 10);
      var storeKey = 'murg_' + (el.getAttribute('data-key') || 'default');
      var deadline;

      function computeDeadline() {
        if (mode === 'fixed') {
          var d = new Date((el.getAttribute('data-deadline') || '').replace(' ', 'T'));
          return isNaN(d.getTime()) ? Date.now() + mins * 60000 : d.getTime();
        }
        var now = Date.now();
        var stored = parseInt(localStorage.getItem(storeKey) || '0', 10);
        if (!stored || stored < now) {
          stored = now + mins * 60000;
          try { localStorage.setItem(storeKey, String(stored)); } catch (e) {}
        }
        return stored;
      }

      deadline = computeDeadline();

      function tick() {
        var diff = deadline - Date.now();
        if (diff <= 0) {
          if (mode === 'fixed') { timeEl.textContent = '00:00:00'; clearInterval(iv); return; }
          try { localStorage.removeItem(storeKey); } catch (e) {}
          deadline = computeDeadline();
          diff = deadline - Date.now();
        }
        var totalH = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var sec = Math.floor((diff % 60000) / 1000);
        timeEl.textContent = pad(totalH) + ':' + pad(m) + ':' + pad(sec);
      }

      tick();
      var iv = setInterval(tick, 1000);
    }
    function boot() {
      document.querySelectorAll('.murg[data-countdown]').forEach(initBar);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
